import React, { useEffect, useState } from 'react'
import Layout1 from '../../Layouts/Layout1'
import axiosInstanceAuth from '../../apiInstances/axiosInstanceAuth';
import { toast } from 'react-toastify';

const Enquiries = () => {
  const [enquiriesDetails, setEnquiriesDetails] = useState([])
  useEffect(() => {
    getEnquiriesDetails()
  }, [])
  const getEnquiriesDetails = async () => {
    await axiosInstanceAuth
      .get('/get/enquiries')
      .then((res) => {
        if (res.data.status) {
          setEnquiriesDetails(res.data.data)
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((error) => {
        console.log("error", error)
        toast.error(error.message)
      })
  }
  return (
    <Layout1>
      <div className="min-w-[900px] bg-white rounded-2xl shadow-md my-10">
        <table className="w-full table-auto">
          <thead>
            <tr>
              <th className="p-4 text-start text-[#262626] font-bold text-sm lg:text-base">Date</th>
              <th className="p-4 text-start text-[#262626] font-bold text-sm lg:text-base">Name</th>
              <th className="p-4 text-start text-[#262626] font-bold text-sm lg:text-base">Mobile No.</th>
              <th className="p-4 text-start text-[#262626] font-bold text-sm lg:text-base">Email</th>
              <th className="p-4 text-start text-[#262626] font-bold text-sm lg:text-base">Message</th>
            </tr>
          </thead>
          <tbody>
            {enquiriesDetails?.length > 0 &&
              enquiriesDetails.map((d, index) => (
                <tr key={index} className="border-t border-t-[#D4D4D4]">
                  <td className="p-4 text-[#262626] font-semibold text-sm lg:text-base">
                    {d.createdAt.split("T")[0]}
                  </td>
                  <td className="p-4 text-[#262626] font-medium text-xs md:text-sm lg:text-base">
                    {d.first_name} {d.last_name}
                  </td>
                  <td className="p-4 text-[#262626] font-medium text-xs md:text-sm lg:text-base">
                    {d.mobile_no}
                  </td>
                  <td className="p-4 text-[#262626] font-medium text-xs md:text-sm lg:text-base">
                    {d.email}
                  </td>
                  <td className="p-4 text-[#262626] font-medium text-xs md:text-sm lg:text-base">
                    {d.message}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

    </Layout1>
  )
}

export default Enquiries